import { api } from "_shared/_stores/api";
import { logSchemaFailure } from "_shared/_utilities/log-schema-failure";
import {
  NotificationEmailReminderOperationsSchema,
  type NotificationEmailReminderOperationsJSON,
} from "notifications/email-reminders/_schemas/notification-email-reminder-operations-schema";

const OPERATIONS_URL = "super-user/notification-email-reminders";
const OPERATIONS_TAG = { type: "NotificationEmailReminderOperations", id: "CURRENT" } as const;

/** Pause or resume reminder emails. A reason is required to pause. */
export type NotificationEmailReminderSwitchCommand = { paused: true; reason: string } | { paused: false };

/** The super user tab's read of reminder emails, and the pause that stops them without a deploy. */
export const notificationEmailReminderOperationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNotificationEmailReminderOperations: build.query<NotificationEmailReminderOperationsJSON, void>({
      query: () => ({ url: OPERATIONS_URL, method: "GET" }),
      rawResponseSchema: NotificationEmailReminderOperationsSchema,
      onSchemaFailure: logSchemaFailure,
      providesTags: [OPERATIONS_TAG],
    }),
    setNotificationEmailReminderSwitch: build.mutation<
      NotificationEmailReminderOperationsJSON,
      NotificationEmailReminderSwitchCommand
    >({
      query: (command) => ({ url: `${OPERATIONS_URL}/switch`, method: "PUT", body: command }),
      rawResponseSchema: NotificationEmailReminderOperationsSchema,
      onSchemaFailure: logSchemaFailure,
      // The answer is the whole tab as it now stands, so it replaces the read rather than refetching it.
      async onQueryStarted(_command, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled.catch(() => ({ data: undefined }));
        if (!data) return;
        dispatch(
          notificationEmailReminderOperationsApi.util.upsertQueryData("getNotificationEmailReminderOperations", undefined, data),
        );
      },
    }),
  }),
});

export const { useGetNotificationEmailReminderOperationsQuery, useSetNotificationEmailReminderSwitchMutation } =
  notificationEmailReminderOperationsApi;
